import { useEffect, useState } from 'react';
import NewsletterSignup from './NewsletterSignup';

const SUBSCRIBED_KEY = 'iasc_newsletter_subscribed'; // localStorage — permanent
const SHOWN_THIS_SESSION_KEY = 'iasc_newsletter_shown'; // sessionStorage — per-tab
const SCROLL_TRIGGER_RATIO = 0.3; // show once the visitor has scrolled ~30% down the page

export default function NewsletterModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Never show again once someone has actually subscribed.
    if (localStorage.getItem(SUBSCRIBED_KEY) === 'true') return;
    // Already shown once this tab session — don't show again until a new tab/session.
    if (sessionStorage.getItem(SHOWN_THIS_SESSION_KEY) === 'true') return;

    const handleScroll = () => {
      const scrolledRatio =
        window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (scrolledRatio >= SCROLL_TRIGGER_RATIO) {
        setOpen(true);
        sessionStorage.setItem(SHOWN_THIS_SESSION_KEY, 'true');
        window.removeEventListener('scroll', handleScroll);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSuccess = () => {
    localStorage.setItem(SUBSCRIBED_KEY, 'true');
    setTimeout(() => setOpen(false), 1800); // brief pause so they see the confirmation before it closes
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 z-[200] flex items-center justify-center p-4"
      onClick={() => setOpen(false)}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 p-1.5 rounded-full text-[#64748b] hover:bg-[#f2f4f6] transition-colors"
          aria-label="Close"
        >
          <span className="material-symbols-outlined">close</span>
        </button>

        <div className="w-14 h-14 rounded-2xl bg-[#00255a]/5 flex items-center justify-center mb-4">
          <span className="material-symbols-outlined text-[#00255a] text-3xl">mail</span>
        </div>
        <h3 className="text-xl font-bold text-[#00255a] mb-2">Never miss a new opening</h3>
        <p className="text-sm text-[#64748b] mb-6">
          Get an email the moment new study and job openings go live — no need to keep checking back.
        </p>

        <NewsletterSignup onSuccess={handleSuccess} />
      </div>
    </div>
  );
}